<template>
  <div>
    <el-row>
      <el-col :span="22">
        <el-row v-if="item.categoryName != '商圈积分'" class="f-z17 lh40">
          <label v-if="role == 1">
            <el-col :span="8" class="f-z15" style="color: #247FEA;">
              {{ item.categoryName }}预警
            </el-col>
            <el-col :span="16" class="f-z15" style="color: #c0c0c0;">
              预警周期：{{ item.startDate }} - {{ item.endDate }}
            </el-col>
            <el-row v-if="parseInt(item.mdCount) > 0">
              <el-col :span="8" class="f-z15" >
                预警门店数量：{{ item.mdCount }}
              </el-col>
            </el-row>
          </label>
          <label v-if="role == 2">
            <el-col :span="8" class="f-z15" style="color: #247FEA;">
              {{ item.categoryName }}预警
            </el-col>
            <el-col :span="16" class="f-z15" style="color: #c0c0c0;">
              预警周期：{{ item.startDate }} - {{ item.endDate }}
            </el-col>
            <el-row>
              <label v-if="item.categoryName == '空铺'">
                <el-col :span="8" class="f-z15" >
                  空铺：{{ item.emptyShopCount }}
                </el-col>
                <el-col :span="8" class="f-z15" >
                  超期空铺：{{ item.emptyShopOverdueCount }}
                </el-col>
              </label>
              <label v-if="myArr.indexOf(item.categoryName) != -1">
                <el-col :span="8" class="f-z14">
                  {{ item.categoryName }}：{{ item.dataIn }}
                </el-col>
                <el-col :span="8" class="f-z14">
                  <span v-if="item.categoryName == '客流'">同比：</span>
                  <span v-else>同期差：</span>
                  <i v-if="item.fh" :class="item.fh == 1 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" :style="item.fh == 1 ? 'color: green' : 'color: red'"></i>{{ item.tb }}%
                </el-col>
                <el-col :span="8" class="f-z14">
                  标准值差异：<span v-if="item.fh1 && item.fh1 == 2">-</span>{{ item.ysjd }}
                </el-col>
              </label>
            </el-row>
          </label>
          <label v-if="role == 3">
            <el-col :span="8" class="f-z15" style="color: #247FEA;">
              {{ item.categoryName }}预警
            </el-col>
            <el-col :span="16" class="f-z15" style="color: #c0c0c0;">
              预警周期：{{ item.startDate }} - {{ item.endDate }}
            </el-col>
          </label>
        </el-row>
        <el-row v-else class="f-z17 lh40">
          <el-col :span="22">
            <el-row class="f-z17 lh40">
              <el-col :span="8" class="f-z15" style="color: #247FEA;">
                {{ item.categoryName }}预警
              </el-col>
              <el-col :span="16" class="f-z15" style="color: #c0c0c0;">
                预警周期：{{ item.startDate }} - {{ item.endDate }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="2" :style="role != 3 ? 'line-height: 100px;cursor: pointer' : 'line-height: 50px;cursor: pointer'">
        <i @click="toMsgDetail(item)" class="el-icon-arrow-right"></i>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { default as AlarmOrderApi } from '@/api/alarm/order/AlarmOrderApi.js'
export default {
  name: "messageItem",
  props: ['item', 'role'],
  data() {
    return {
      myArr: ['毛利率', '客流', '营收']
    }
  },
  created() {
	console.log(this.role)  
  },
  methods: {
    toMsgDetail(item) {
      this.$emit("addCallbackReturn", item)
    },
  }
}
</script>

<style scoped>
	.f-z17 {
	  font-size: 16px;
	}
	.f-z16 {
	  font-size: 15px;
	}
	.f-z15 {
	  font-size: 14px;
	  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,apple color emoji,segoe ui emoji,Segoe UI Symbol,noto color emoji;
	}
	.f-z14 {
	  font-size: 13px;
	  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,apple color emoji,segoe ui emoji,Segoe UI Symbol,noto color emoji;
	  text-align: left;
	}
	.lh40 {
	  line-height: 40px;
	  padding: 10px 0px;
	}
</style>